import { useEffect } from "react";

import { HeaderWithNextButtonLayout } from "@components";
import {
  AbroadPostings,
  DeputationPostings,
  ForeignTravelPostings,
  PostingRecordPostings,
} from "./components";

import { usePostings } from "@hooks/HRM/employee/usePostings";

export interface PostingsPropsType {
  id: number | null;
  changeActiveTab: (arg: number) => void;
  setIsSuccessModalOpen: (arg: boolean) => void;
  setIsErrorModalOpen: (arg: boolean) => void;
  isProfileDisabled: boolean;
}

function Postings({
  id,
  changeActiveTab,
  setIsSuccessModalOpen,
  setIsErrorModalOpen,
  isProfileDisabled,
}: PostingsPropsType) {
  const {
    postingsInfo,

    changeAbroadPostingsInfo,
    changeDeputationPostingsInfo,
    changePostingRecordPostingsInfo,
    changeForeignTravelPostingsInfo,

    removeAbroadPostingInfo,
    removeDeputationPostingInfo,
    removePostingRecordPostingInfo,
    removeForeignTravelPostingInfo,

    getPostingRequestOngoing,

    updateAbroadPostingRequestOngoing,
    updateAbroadPostingSuccess,
    updateAbroadPostingFailed,

    updateDeputationPostingRequestOngoing,
    updateDeputationPostingSuccess,
    updateDeputationPostingFailed,

    updatePostingRecordPostingRequestOngoing,
    updatePostingRecordPostingSuccess,
    updatePostingRecordPostingFailed,

    updateForeignTravelPostingRequestOngoing,
    updateForeignTravelPostingSuccess,
    updateForeignTravelPostingFailed,

    deleteAbroadPostingRequestOngoing,
    deleteAbroadPostingSuccess,
    deleteAbroadPostingFailed,

    deleteDeputationPostingRequestOngoing,
    deleteDeputationPostingSuccess,
    deleteDeputationPostingFailed,

    deletePostingRecordPostingRequestOngoing,
    deletePostingRecordPostingSuccess,
    deletePostingRecordPostingFailed,

    deleteForeignTravelPostingRequestOngoing,
    deleteForeignTravelPostingSuccess,
    deleteForeignTravelPostingFailed,
  } = usePostings(id);

  const { postingAbroads, deputationPostings, postingRecords, foreignTravels } =
    postingsInfo || {};

  useEffect(() => {
    setIsSuccessModalOpen(
      updateAbroadPostingSuccess ||
        updateDeputationPostingSuccess ||
        updatePostingRecordPostingSuccess ||
        updateForeignTravelPostingSuccess ||
        deleteAbroadPostingSuccess ||
        deleteDeputationPostingSuccess ||
        deletePostingRecordPostingSuccess ||
        deleteForeignTravelPostingSuccess,
    );
    setIsErrorModalOpen(
      updateAbroadPostingFailed ||
        updateDeputationPostingFailed ||
        updatePostingRecordPostingFailed ||
        updateForeignTravelPostingFailed ||
        deleteAbroadPostingFailed ||
        deleteDeputationPostingFailed ||
        deletePostingRecordPostingFailed ||
        deleteForeignTravelPostingFailed,
    );
  }, [
    updateAbroadPostingSuccess,
    updateDeputationPostingSuccess,
    updatePostingRecordPostingSuccess,
    updateForeignTravelPostingSuccess,
    deleteAbroadPostingSuccess,
    deleteDeputationPostingSuccess,
    deletePostingRecordPostingSuccess,
    deleteForeignTravelPostingSuccess,
    updateAbroadPostingFailed,
    updateDeputationPostingFailed,
    updatePostingRecordPostingFailed,
    updateForeignTravelPostingFailed,
    deleteAbroadPostingFailed,
    deleteDeputationPostingFailed,
    deletePostingRecordPostingFailed,
    deleteForeignTravelPostingFailed,
  ]);

  return (
    <HeaderWithNextButtonLayout
      title="EMPLOYEE.POSTINGS_INFO.HEADING"
      subtitle="EMPLOYEE.POSTINGS_INFO.DESCRIPTION"
      action={() => changeActiveTab(6)}
    >
      <div className="d-flex flex-column gap-10">
        <AbroadPostings
          abroadPostingsInfo={postingAbroads}
          changeAbroadPostingsInfo={changeAbroadPostingsInfo}
          removeAbroadPostingInfo={removeAbroadPostingInfo}
          getPostingRequestOngoing={getPostingRequestOngoing}
          updateAbroadPostingRequestOngoing={updateAbroadPostingRequestOngoing}
          deleteAbroadPostingRequestOngoing={deleteAbroadPostingRequestOngoing}
          isProfileDisabled={isProfileDisabled}
        />
        <DeputationPostings
          deputationPostingsInfo={deputationPostings}
          changeDeputationPostingsInfo={changeDeputationPostingsInfo}
          removeDeputationPostingInfo={removeDeputationPostingInfo}
          getPostingRequestOngoing={getPostingRequestOngoing}
          updateDeputationPostingRequestOngoing={
            updateDeputationPostingRequestOngoing
          }
          deleteDeputationPostingRequestOngoing={
            deleteDeputationPostingRequestOngoing
          }
          isProfileDisabled={isProfileDisabled}
        />
        <PostingRecordPostings
          postingRecordPostingsInfo={postingRecords}
          changePostingRecordPostingsInfo={changePostingRecordPostingsInfo}
          removePostingRecordPostingInfo={removePostingRecordPostingInfo}
          getPostingRequestOngoing={getPostingRequestOngoing}
          updatePostingRecordPostingRequestOngoing={
            updatePostingRecordPostingRequestOngoing
          }
          deletePostingRecordPostingRequestOngoing={
            deletePostingRecordPostingRequestOngoing
          }
          isProfileDisabled={isProfileDisabled}
        />
        <ForeignTravelPostings
          foreignTravelPostingsInfo={foreignTravels}
          changeForeignTravelPostingsInfo={changeForeignTravelPostingsInfo}
          removeForeignTravelPostingInfo={removeForeignTravelPostingInfo}
          getPostingRequestOngoing={getPostingRequestOngoing}
          updateForeignTravelPostingRequestOngoing={
            updateForeignTravelPostingRequestOngoing
          }
          deleteForeignTravelPostingRequestOngoing={
            deleteForeignTravelPostingRequestOngoing
          }
          isProfileDisabled={isProfileDisabled}
        />
      </div>
    </HeaderWithNextButtonLayout>
  );
}

export default Postings;
